import React from 'react'
import styles from './QuickStats.scss'
import { DashedMetric } from 'common/DashedMetric'
import { SectionBox } from 'common/styleguide/SectionBox'
import cx from 'classnames'
import p from 'prop-types'

export const QuickStats = ({ totals, rows, title, labelsUnder, bottomMargin, className }) => {
  const width = rows && rows <= 4 ? `${25 * rows}%` : '25%'

  return (
    <SectionBox title={title || 'Stats'} noPadding className={className}>
      <div className={styles.inner}>
        {['today', 'this week', 'this month', 'this year'].map((v, i) => (
          <DashedMetric
            key={i}
            label={v}
            value={totals && totals.hasOwnProperty(v) && totals[`${v}`]}
            width={width}
            className={cx(styles.metric, labelsUnder && styles.labelsUnder, bottomMargin && styles.bottomMargin)} />
        ))}
      </div>
    </SectionBox>
  )
}

QuickStats.propTypes = {
  totals: p.shape({
    today: p.number.isRequired,
    'this week': p.number.isRequired,
    'this month': p.number.isRequired,
    'this year': p.number.isRequired
  }),
  rows: p.number // only pass 1, 2, or 4 for rows if you know what's good for you
}
